import { render, staticRenderFns } from "./WBjhTable.vue?vue&type=template&id=a428298e&scoped=true"
import script from "./WBjhTable.vue?vue&type=script&lang=js"
export * from "./WBjhTable.vue?vue&type=script&lang=js"
import style0 from "./WBjhTable.vue?vue&type=style&index=0&id=a428298e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a428298e",
  null
  
)

export default component.exports